export enum ResearchAreaFormat {
    Individual = 'Individual',
    Group = 'Group',
    IndividualGroup = 'IndividualGroup',
}
